import { observer } from 'mobx-react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { currentUserStore } from '../../../../CurrentUserStore';
import { T } from '../../../../Translations';
import { useQueryWithDecoder } from '../../../../UseQueryWithDecoder';
import { ssoConfigurationsResourceDecoder } from '../../Decoders';
import { ConnectionResource } from '../../Types';

interface Props {
  resource: ConnectionResource;
}

// Domain assignment lives on the hub (it is the hub's normal state, not a
// wizard step), so this card reads the hub resource and links back to it.
const AssignedDomains: React.FC<Props> = ({ resource }) => {
  const { data } = useQueryWithDecoder(
    'sso-configurations',
    currentUserStore.links,
    ssoConfigurationsResourceDecoder,
  );

  const assignedDomains = data
    ? data.payload.loginDomains.filter((loginDomain) =>
        loginDomain.ssoConnectionId.map((id) => id === resource.payload.id).getOrElseValue(false),
      )
    : [];

  return (
    <div>
      <h3 className="text-base font-semibold text-foreground">
        <T kind="Assigned domains" />
      </h3>
      <div className="mt-3 rounded-lg border border-border bg-card p-6">
        {assignedDomains.length > 0 ? (
          <ul className="m-0 flex list-none flex-col p-0">
            {assignedDomains.map((loginDomain) => (
              <li
                key={loginDomain.id}
                className="border-b border-border py-2 text-sm font-medium text-foreground last:border-b-0"
              >
                {loginDomain.domain}
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-muted-foreground">
            <T kind="No domains are assigned to this connection." />
          </p>
        )}
        <p className="mt-4 text-sm text-muted-foreground">
          <T kind="Assign or change domains from the Single Sign-On page." />{' '}
          <Link to="/single_sign_on" className="text-primary hover:underline">
            <T kind="Single Sign-On" />
          </Link>
        </p>
      </div>
    </div>
  );
};

export default observer(AssignedDomains);
